module.exports = __webpack_public_path__ + "assets/0a2a610300f06ecf47bd54614a786ff3.png";